import { Link } from "react-router-dom";
import { Play } from "lucide-react";
import { posterUrl } from "../lib/api";

export default function MovieCard({ movie, index = 0, size = "md" }) {
  const sizes = {
    sm: "w-40 sm:w-44",
    md: "w-52 sm:w-60",
    lg: "w-64 sm:w-72",
  };
  return (
    <Link
      to={`/movie/${movie.id}`}
      data-testid={`movie-card-${movie.id}`}
      className={`${sizes[size]} shrink-0 group relative block animate-fade-up`}
      style={{ animationDelay: `${index * 60}ms`, opacity: 0 }}
    >
      <div className="relative aspect-[2/3] overflow-hidden rounded-lg border border-white/5 bg-[#141414]">
        <img
          src={posterUrl(movie.id)}
          alt={movie.title}
          loading="lazy"
          className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
          onError={(e) => { e.currentTarget.style.display = "none"; }}
        />
        <div className="absolute inset-0 poster-overlay" />
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="h-14 w-14 rounded-full bg-[#E65F2B] flex items-center justify-center shadow-2xl">
            <Play className="h-6 w-6 text-white fill-white ml-1" />
          </div>
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <p className="text-xs uppercase tracking-wider text-[#E65F2B] font-semibold">{(movie.genres && movie.genres.length ? movie.genres : [movie.genre]).filter(Boolean).join(" · ")}</p>
          <h3 className="font-display font-bold text-white leading-tight mt-0.5 line-clamp-2">{movie.title}</h3>
          <p className="text-[11px] text-white/50 mt-1 truncate">{movie.channel_name}</p>
        </div>
      </div>
    </Link>
  );
}
